
import { Trainings } from './trainings.model';
import { environment } from 'src/environments/environment';

export class CandidatesTrainings {
  private id: number;
  private level_of_study: string;
  private trainings: Trainings;
  private university: string;
  private period_start: string;
  private period_end: string;
  private in_progress: string;
  private diploma_path: string;

  constructor(CandidatesTrainings: any) {
    this.id = CandidatesTrainings.id;
    this.level_of_study = CandidatesTrainings.level_of_study;
    this.trainings = CandidatesTrainings.trainings;
    this.university = CandidatesTrainings.university;
    this.period_start = CandidatesTrainings.period_start;
    this.period_end = CandidatesTrainings.period_end;
    this.in_progress = CandidatesTrainings.in_progress;
    this.diploma_path = CandidatesTrainings.diploma_path;
  }

  getId(): number {
    return this.id;
  }

  getLevelOfStudy(): string {
    return this.level_of_study;
  }

  getTrainings(): Trainings {
    return this.trainings;
  }

  getUniversity(): string {
    return this.university;
  }

  getPeriodStart(): string {
    return this.period_start;
  }

  getPeriodEnd(): string {
    return this.period_end;
  }

  getInProgress(): string {
    return this.in_progress;
  }

  getDiplomaPath(): string {
    return (this.diploma_path != null && this.diploma_path != '') ? environment.apiUrl + this.diploma_path : this.diploma_path;
  }

}